export default "__VITE_ASSET__V_YIEj2b__"